/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { BaseTrendChartContext } from '../contexts';

export const useBaseTrendChartStore = () => useContext(BaseTrendChartContext);
